import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

// services
import { GlobleService } from 'src/app/core/services/globle.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// classes
import { CategoryHandler } from 'src/app/core/classes/category-handler';
import { LocationHandler } from 'src/app/core/classes/location-handler';

// enums
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';


@Injectable()
export class FiltrationService {

  /**
   * fields
   */
  public isOpen: boolean = false;
  public isLoading: boolean = false;
  private _form: UntypedFormGroup = null;
  private _categoryHandler: CategoryHandler = null;
  private _locationHandler: LocationHandler = null;     
  public readonly watchChange: BehaviorSubject<{[key: string]: any} | null> = new BehaviorSubject(null)

  /** */
  constructor(
    private _g: GlobleService,
    private _fb: UntypedFormBuilder,
    private _api: ApiResponseService,
  ) {

    /**
     * init form
     */
    this._initFrom();

    /**
     * init LocationHandler
     */
    this._locationHandler = new LocationHandler([], this._api);

    // watch changes to reset controls Values for locationHandler
    this.locationHandler
      .watchChange
      .subscribe(index => {
        this.locationHandler
          .sortedControls
          .slice(index)
          .forEach(controlName => this.Form.get(controlName).reset())
      })     
    
    /**
     * init CategoryHandler
     */      
    this._categoryHandler = new CategoryHandler([]); 
    
    // watch changes to reset controls Values for categoryHandler
    this.categoryHandler
      .watchChange
      .subscribe(_ => {
        this.Form.get('subCategory').reset();
      })   

    /**
     * caller
     */
    const categories = this._api.mainCategories({
      params: { [RANDOM_VALUE.loader]: true } 
    });
    this.categoryHandler.isLoadingItems = true;

    const cities = this._api.getCitiesByCountry(this._g.userInfo.country.id, {
      params: { [RANDOM_VALUE.loader]: true } 
    });
    this.locationHandler.isLoadingCities = true;

    /**
     * combine
     */
    combineLatest([categories, cities])
    .subscribe(
      res => {

        /**
         * stop loading
         */
        this.categoryHandler.isLoadingItems = false;
        this.locationHandler.isLoadingCities = false;

        // ES6 Destruction
        const [categories, cities] = res;

        /**
         * 
         */
        this.locationHandler.cities = cities;
        this.categoryHandler.items = categories;

    });    

  }

  // getter & setter

  /**
   * form
   */
  public get Form(): UntypedFormGroup | null {
    return this._form
  }

  /**
   * categoryHandler
   */
  public get categoryHandler(): CategoryHandler {
    return this._categoryHandler
  }

  /**
   * locationHandler
   */
  public get locationHandler(): LocationHandler {
    return this._locationHandler
  }  

  // Methods

  /**
   * close
   */
  public close(): void {
    this.isOpen = false;
  }

  /**
   * open
   */
  public open(): void {
    this.isOpen = true;
  }   

  /**
   * handler form
   */
  private _initFrom(): void {
      
    this._form = this._fb.group({
        city: [null],
        area: [null],
        category: [null],
        subCategory: [null],
    })

  }

  /**
   * 
   */
  public OnDestroy(): void {
    this.Form.reset();
    this.watchChange.next(null)
  }

}
